import React from 'react';
import { useSelector, useDispatch } from 'react-redux'
import {
	CButton,
	CForm,
	CFormInput,
	CFormSelect,
	CFormTextarea,
	CInputGroup,
	CInputGroupText,
	CSpinner,
	CTooltip,
	CCard,
	CCardHeader,
	CCardBody,
	CCardFooter,
	CRow,
	CCol,
	CLink,
	CImage,
} from '@coreui/react';
import PropTypes from 'prop-types';
import CIcon from '@coreui/icons-react'
import { isMobile } from "react-device-detect";
import { Konfirm } from '../helpers/onConfirm'
import { 
	UFunc,
	cAngkaTgl,
	cBulanPendek
} from "../helpers/functions";
import {
	MyButton,
	MyDialoglookup,
} from '../components/index'
import useSatusehat from '../helpers/useSatusehat'

const pjson 			= require('../../package.json')
const MyCardformpasien 	= props => {
	const { 
		pasienID,
		showButton,
		simpanKlik,
		setLoading,
		prosesExpired,
		showToast,
		setSessionaktif,
		...rest 
	} = props;

	const uDispatch 			= useDispatch();
	const { loadToken } 		= useSatusehat(props);
	const [uShowbutton,setShowbutton]	= React.useState(showButton);

	const uBahasaObj	= useSelector(state => state.listBahasa);
	const uSystemsetting= useSelector(state => state.gSystemsetting)
	const uTokenObj		= JSON.parse(localStorage.getItem("token")||"{}");
	const [uEfekview,setEfekview] 			= React.useState(false);
	const uTokensatusehatObj		= JSON.parse(localStorage.getItem("tokensatusehat")||"{}");

	//const [uSettingdefault,setSettingdefault] = React.useState({});
	const [uThnlahirArr,setThnlahirArr] 	= React.useState([]);
	const [uPasienloadObj,setPasienloadObj] = React.useState({});
	const [uIsDlgloading,setDlgloading]		= React.useState(false);
	const [uApimsg,setApimsg]  				= React.useState(null);
	const [uPekerjaanArr,setPekerjaanArr]	= React.useState([]);
	const [uAsuransiArr,setAsuransiArr]		= React.useState([]);
	const [uAgamaArr,setAgamaArr]			= React.useState([]);
	const [uWilayahObj,setWilayahObj]		= React.useState({});

	const [uFormfieldObj,setFormfieldObj]	= React.useState({});

	//---DLG_LOOKUP--/
	const [uISDlglookupshow,setDlglookupshow]= React.useState(false);
	const [uDlglookupObj,setDlglookupObj]	= React.useState({});
	//---END DLG_LOOKUP--/

	const hdlKlikpekerjaanlookup = () => {
		uDlglookupObj.data_arr 		= uPekerjaanArr||[];
		uDlglookupObj.inputvalue 	= uFormfieldObj.pekerjaan_caption;
		uDlglookupObj.headers 		= "Pilih: Pekerjaan";
		uDlglookupObj.jenis 		= "PEKERJAAN";
		setDlglookupshow(true);
	}
	const hdlKDownpekerjaan = (_EV) => {
		uFormfieldObj.pekerjaan_id = (0);
		if(_EV.which !== 13) return;

		const vCaptions			= (uFormfieldObj.pekerjaan_caption||"").trim();
		if(vCaptions === "") return;

		const vFilterlookupArr = uPekerjaanArr.filter(vItems=>
			(vItems.caption||"").toUpperCase().includes((vCaptions).toUpperCase()));

		if(vFilterlookupArr.length <= 1) {
			if(vFilterlookupArr.length === 1) {
				uFormfieldObj.pekerjaan_id = (vFilterlookupArr[0].id);
				uFormfieldObj.pekerjaan_caption = (vFilterlookupArr[0].caption);
			}
			return;			
		}

		_EV.stopPropagation();
		_EV.preventDefault();
		hdlKlikpekerjaanlookup();
	}
	const hdlKlikasuransilookup = () => {
		uDlglookupObj.data_arr 		= uAsuransiArr||[];
		uDlglookupObj.inputvalue 	= uFormfieldObj.asuransi_caption;
		uDlglookupObj.headers 		= "Pilih Lookup: ASURANSI";
		uDlglookupObj.jenis 		= "ASURANSI";
		setDlglookupshow(true);
	}
	const hdlKDownasuransi = (_EV) => {
		uFormfieldObj.asuransi_id = (0);
		if(_EV.keyCode !== 13) return;

		const vCaptions			= (uFormfieldObj.asuransi_caption||"").trim();
		if(vCaptions === "") return;

		const vFilterlookupArr = uAsuransiArr.filter(vItems=>
			(vItems.caption||"").toUpperCase().includes((vCaptions).toUpperCase()));

		_EV.stopPropagation();
		_EV.preventDefault();

		if(vFilterlookupArr.length === 1) {
			uFormfieldObj.asuransi_id = (vFilterlookupArr[0].id);
			uFormfieldObj.asuransi_caption = (vFilterlookupArr[0].caption);

			document.getElementById("inppekerjaan") &&
				document.getElementById("inppekerjaan").focus();
			return;
		}
		hdlKlikasuransilookup();
	}
	const hdlKlikagamalookup = () => {
		setDlglookupObj({
			data_arr: uAgamaArr.map(vItems=>{ return {id:vItems.id,caption:vItems.nama_agama} }),
			inputvalue: "",
			headers: "Lookup: AGAMA",
			jenis: "AGAMA",
		});
		setDlglookupshow(true);
	}
	const hdlKlikDlglookuppilih = (_IDITEM) => {
		_IDITEM 		= parseInt(_IDITEM);
		let vArridx;
		let vElfocus;
		if(uDlglookupObj.jenis === "PEKERJAAN") {
			vArridx 	= UFunc.getObjectIndeks(uPekerjaanArr,_IDITEM);
			uFormfieldObj.pekerjaan_id = (uPekerjaanArr[vArridx].id);
			uFormfieldObj.pekerjaan_caption = (uPekerjaanArr[vArridx].caption||"");
			vElfocus 	= document.getElementById("inpalergi");
		} else if(uDlglookupObj.jenis === "AGAMA") {
			vArridx 	= UFunc.getObjectIndeks(uAgamaArr,_IDITEM);
			setFormfieldObj({...uFormfieldObj,
				agama_id: (uAgamaArr[vArridx].id),
				agama_caption: (uAgamaArr[vArridx].nama_agama||""),
			});
			vElfocus 	= document.getElementById("inptelphp");
		} else if(uDlglookupObj.jenis === "ASURANSI") {
			vArridx 	= UFunc.getObjectIndeks(uAsuransiArr,_IDITEM);
			uFormfieldObj.asuransi_id = (uAsuransiArr[vArridx].id);
			uFormfieldObj.asuransi_caption = (uAsuransiArr[vArridx].caption||"");
			vElfocus 	= document.getElementById("inppekerjaan");
		} else if(uDlglookupObj.jenis === "PROPINSI") {
			vArridx 	= UFunc.getObjectIndeks((uWilayahObj.propinsi_arr || []),_IDITEM,"code");
			uFormfieldObj.propinsi = (uWilayahObj.propinsi_arr || [])[vArridx] || {};
			vElfocus 	= document.getElementById("btnkota");

			uFormfieldObj.kota 		= undefined;
			uFormfieldObj.distrik	= undefined;
			uFormfieldObj.village	= undefined;
		} else if(uDlglookupObj.jenis === "KOTA") {
			vArridx 	= UFunc.getObjectIndeks((uWilayahObj.kota_arr || []),_IDITEM,"code");
			uFormfieldObj.kota = (uWilayahObj.kota_arr || [])[vArridx] || {};
			vElfocus 	= document.getElementById("btndistrik");

			uFormfieldObj.distrik	= undefined;
			uFormfieldObj.village	= undefined;
		} else if(uDlglookupObj.jenis === "DISTRIK") {
			vArridx 	= UFunc.getObjectIndeks((uWilayahObj.distrik_arr || []),_IDITEM,"code");
			uFormfieldObj.distrik = (uWilayahObj.distrik_arr || [])[vArridx] || {};
			vElfocus 	= document.getElementById("btnvillage");

			uFormfieldObj.village	= undefined;
		} else if(uDlglookupObj.jenis === "VILLAGE") {
			vArridx 	= UFunc.getObjectIndeks((uWilayahObj.village_arr || []),_IDITEM,"code");
			uFormfieldObj.village = (uWilayahObj.village_arr || [])[vArridx] || {};
			vElfocus 	= document.getElementById("inpasuransi");
		}
		setDlglookupshow(false);	

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout)
			if(!isMobile) vElfocus && vElfocus.focus()
		},400)
	}
	const hdlKlikWilayah = (_JENIS) => {
		_JENIS = (_JENIS||"").toUpperCase();

		let vDatalookupArr;
		let vCaptionupper;
		if(_JENIS === "PROPINSI") {
			vDatalookupArr = (uWilayahObj.propinsi_arr || []).map(vItems=>{
				return {id:vItems.code,caption:(vItems.name||"").toUpperCase()}
			})
			vCaptionupper = (uBahasaObj.word_propinsi||"Propinsi").toUpperCase();
		} else if(_JENIS === "KOTA") {
			if(uFormfieldObj.propinsi === undefined) {
				showToast("Nama PROPINSI Harus Dipilih Dahulu !");
				return;
			}

			vDatalookupArr = (uWilayahObj.kota_arr || []).map(vItems=>{
				return {id:vItems.code,caption:(vItems.name||"").toUpperCase()}
			})
			vCaptionupper = (uBahasaObj.word_kota||"Kota").toUpperCase();
		} else if(_JENIS === "DISTRIK") {
			if(uFormfieldObj.kota === undefined) {
				showToast("Nama KOTA Harus Dipilih Dahulu !");
				return;
			}
			
			vDatalookupArr = (uWilayahObj.distrik_arr || []).map(vItems=>{
				return {id:vItems.code,caption:(vItems.name||"").toUpperCase()}
			})
			vCaptionupper = (uBahasaObj.word_distrik||"Distrik").toUpperCase();
		} else if(_JENIS === "VILLAGE") {
			if(uFormfieldObj.distrik === undefined) {
				showToast("Nama KECAMATAN Harus Dipilih Dahulu !");
				return;
			}
			
			vDatalookupArr = (uWilayahObj.village_arr || []).map(vItems=>{
				return {id:vItems.code,caption:(vItems.name||"").toUpperCase()}
			})
			vCaptionupper = (uBahasaObj.word_village||"Village").toUpperCase();
		}

		if((vDatalookupArr||[]).length > 0) {
			uDlglookupObj.jenis			= _JENIS;
			uDlglookupObj.data_arr		= vDatalookupArr;
			uDlglookupObj.headers		= (uBahasaObj.word_lookup||"Lookup")+": "+vCaptionupper;
			setDlglookupshow(true)
			
			return;
		}
		
		const vAccesstoken 		= uTokensatusehatObj.access_token;
 		if(!vAccesstoken) {
 			showToast("<b>Status Token Satusehat BELUM TERKONEKSI</b>.."+
 				"<br/>Mohon Set API KEY dengan Benar, Kemudian Klik GET NEW TOKEN !"+
 			"");return
 		}

		apiLoadwilayah(_JENIS)
	}
	const hdlKlikResetwilayah = async() => {
		const vNextfunction = () => {
			uFormfieldObj.propinsi 	= undefined;
			uFormfieldObj.kota 		= undefined;
			uFormfieldObj.distrik 	= undefined;
			uFormfieldObj.village 	= undefined;
			setEfekview(!uEfekview);
		}

		if(uFormfieldObj.propinsi === undefined){
			vNextfunction();
			return;
		}

		if(await Konfirm("<b>Data Kewilayahan Alamat Akan Direset</b>.."+
			"<br/>Apakah Anda Yakin ?"+
			"")) vNextfunction();
	}

	const hdlKlikSimpan = async() => {
		let vElfocus = document.getElementById("inpnamalengkap");
		if((uFormfieldObj.nama_lengkap_pasien||"").trim() === "") {
			vElfocus && vElfocus.focus();
			showToast("Nama Lengkap Pasien Harus Diisi !"); return;
		}
		
		vElfocus = document.getElementById("inpsex");
		if((uFormfieldObj.sex_pasien||"").trim() !== "L" && (uFormfieldObj.sex_pasien||"").trim() !== "P") {
			vElfocus && vElfocus.focus();
			showToast("Jenis Kelamin Tidak Valid !"); return;
		}

		vElfocus = document.getElementById("inptelphp");
		if((uFormfieldObj.alamat_pasien||"").trim() === "" && (uFormfieldObj.telpon_pasien||"").trim() === "") {
			vElfocus && vElfocus.focus();
			showToast("Salah Satu Dari Telp/HP atau Alamat Harus Diisi !"); return;
		}

		vElfocus = document.getElementById("btnpropinsi");
		if((uFormfieldObj.propinsi !== undefined && (
				uFormfieldObj.kota === undefined
				|| uFormfieldObj.distrik === undefined
				|| uFormfieldObj.village === undefined
				))
			|| (uFormfieldObj.kota !== undefined && (
				uFormfieldObj.distrik === undefined
				|| uFormfieldObj.village === undefined
				))
			|| (uFormfieldObj.distrik !== undefined && (
				uFormfieldObj.village === undefined
				))
			) {
			vElfocus && vElfocus.focus();
			showToast("Data Kewilayahan Alamat Harus Dilengkapi SEMUA !"); return;
		}
		if((uFormfieldObj.nik||"").trim()!==""
			|| parseInt(uFormfieldObj.thn || "0") > 0
			|| parseInt(uFormfieldObj.bln || "0") > 0
			|| parseInt(uFormfieldObj.tgl || "0") > 0
		) {
			const vThnlahir		= UFunc.leadZero(uFormfieldObj.thn,4).toString();
			const vBlnlahir		= UFunc.leadZero(uFormfieldObj.bln,2).toString();
			const vTgllahir		= UFunc.leadZero(uFormfieldObj.tgl,2).toString();
			const vTanggallahir = vThnlahir+"-"+vBlnlahir+"-"+vTgllahir+
				"";
			const vTanggallahirDT	= UFunc.toDate(vTanggallahir);

			vElfocus = document.getElementById("inplahirtgl");
			if((vTanggallahirDT.getDate()) !== parseInt(vTgllahir)) {
				vElfocus && vElfocus.focus();
				showToast("Tanggal Lahir Tidak Valid !"); return;
			}

			vElfocus = document.getElementById("inplahirbln");
			if((vTanggallahirDT.getMonth()+1) !== parseInt(vBlnlahir)) {
				vElfocus && vElfocus.focus();
				showToast("Bulan Lahir Tidak Valid ! "+(vTanggallahirDT.getMonth()+1)+" "+parseInt(vBlnlahir)); return;
			}
			vElfocus = document.getElementById("inplahirthn");
			if(vTanggallahirDT.getFullYear() !== parseInt(vThnlahir)) {
				vElfocus && vElfocus.focus();
				showToast("Tahun Lahir Tidak Valid !"); return;
			}
		}
		vElfocus = document.getElementById("inpasuransi");
		if((uFormfieldObj.asuransi_caption||"").trim() !== "")
			if(parseInt(uFormfieldObj.asuransi_id) <= 0) {
				vElfocus && vElfocus.focus();
				showToast("Nama Asuransi Harus Dipilih dengan Benar !"); return;
			}

		//--CONFIRM_NIK--/
		if((uFormfieldObj.nik||"").trim() === "") {
			if(await Konfirm(
				"<b>NIK Pasien Belum DITAMBAHKAN</b>.."+
				"<small class='fst-italic'>"+
				"<p>Jika NIK Pasien Tidak ADA, Maka Sistem Tidak Akan Mendapatkan IHS Satusehat.</p>"+
				"<p>Apabila IHS Satusehat Tidak Terdaftar, Data Pemeriksaan Tidak Akan Terkirim ke SERVER Satusehat.</p>"+
				"</small>"+
				"Apakah Anda Tetap Akan Melanjutkan ?"+
				"")) apiProsessimpan();
			return;
		}
		//--END CONFIRM_NIK--/

		//showToast("YES"); return;
		apiProsessimpan();
	}
	const hdlKlikReset = async()=>{
		const vNextfunction = ()=>{
			if(parseInt(pasienID) > 0) {
				apiLoadpasien(pasienID); return;
			}

			initFormawal();
		}

		if(await(Konfirm("Apakah Anda Yakin ?"+
			""))) vNextfunction();
	}

	const initFormawal = () => {
		setFormfieldObj({});
		/*uFormfieldObj.nama_lengkap_pasien = ("");
		uFormfieldObj.nama_panggilan_pasien = ("");
		uFormfieldObj.sex_pasien = ("L");
		uFormfieldObj.tgl = ("0"); uFormfieldObj.bln = ("0"); uFormfieldObj.thn = ("0");

		uFormfieldObj.telpon_pasien = ("");
		uFormfieldObj.alamat_pasien = ("");
		uFormfieldObj.pekerjaan_caption = ("");
		uFormfieldObj.pekerjaan_id = (0);
		uFormfieldObj.asuransi_caption = ("");
		uFormfieldObj.asuransi_id = (0);
		uFormfieldObj.alergi = ("");
		uFormfieldObj.keterangan = ("");//--*/
	}

	const contentMain = () => {
		if(uIsDlgloading) return (
			<div className="d-flex justify-content-center align-items-center h-50">
			<CSpinner color="primary"/>
			</div>
		)//>
		if(uApimsg) return (UFunc.renderHTML(uApimsg));

		const vTgldaftarDT = uPasienloadObj.tgl_input 
			? UFunc.toDatetime(uPasienloadObj.tgl_input) : new Date();

		return (
		<>
			<div className="d-none my-2">{JSON.stringify(uFormfieldObj)}</div>
			<CRow className="my-2">
			<CCol md="5" lg="4" className="fw-bolder">Nama Lengkap Pasien</CCol>
			<CCol md="7" lg="8">
				<CFormInput size="sm"
					className="text-capitalize"
					maxLength={100}
					value={uFormfieldObj.nama_lengkap_pasien||""}
					onChange={(e)=>setFormfieldObj({...uFormfieldObj,nama_lengkap_pasien: (e.target.value)})}
					autoComplete="off"
					id="inpnamalengkap"/>
			</CCol>
			</CRow>

			<CRow className="my-2">
			<CCol md="5" lg="4">Panggilan</CCol>
			<CCol md="7" lg="5">
				<CFormInput size="sm"
					className="text-capitalize"
					maxLength={30}
					value={uFormfieldObj.nama_panggilan_pasien||""}
					onChange={(e)=>setFormfieldObj({...uFormfieldObj,nama_panggilan_pasien: (e.target.value)})}
					autoComplete="off"
					id="inppanggilan"/>
			</CCol>
			</CRow>

			<div className="my-3 classborderbottom"/>

			{(parseInt(pasienID) > 0 && 1 === 2) && (
			<CRow className="my-2">
			<CCol md="5" lg="4" className="fw-bolder">No RM</CCol>
			<CCol md="7" lg="5">
				<CInputGroup size="sm">
				<CFormInput size="sm" type="number"
					maxLength={3}
					value={uFormfieldObj.no_rm||""}
					onChange={(e)=>setFormfieldObj({...uFormfieldObj,no_rm: (e.target.value)})}
					onFocus={(e)=>e.target.select()}
					autoComplete="off"
					style={{maxWidth:60,width:"auto"}}
					id="inpnorm"/>
				<span className="mx-1">-</span>
				<CInputGroupText className="py-0">{UFunc.leadZero(vTgldaftarDT.getMonth()+1)}</CInputGroupText>
				<span className="mx-1">-</span>
				<CInputGroupText className="py-0">{vTgldaftarDT.getFullYear()}</CInputGroupText>
				</CInputGroup>
			</CCol>
			</CRow>
			)}

			<CRow className="my-2">
			<CCol md="5" lg="4" className="fw-bolder">NIK</CCol>
			<CCol md="7" lg="5">
				<CFormInput size="sm"
					className="text-uppercase"
					maxLength={50}
					value={uFormfieldObj.nik||""}
					onChange={(e)=>setFormfieldObj({...uFormfieldObj,nik: (e.target.value)})}
					autoComplete="off"
					id="inpnik"/>
			</CCol>
			</CRow>

			<CRow className="my-2">
			<CCol md="5" lg="4" className="">IHS Number</CCol>
			<CCol md="7" lg="5">
				<CFormInput size="sm"
					className="text-uppercase"
					maxLength={30}
					readOnly={true}
					value={uFormfieldObj.ihs_number||""	}
					autoComplete="off"
					id="inpihsnumber"/>
			</CCol>
			</CRow>

			<CRow className="my-2">
			<CCol md="5" lg="4">Tempat, Tgl Lahir</CCol>
			<CCol md="7" lg="8" className="d-md-flex align-items-start">
				<CInputGroup size="sm" 
					style={{maxWidth:225}}
					className="">
				<CFormInput size="sm"
					className="text-capitalize mb-2"
					maxLength={100}
					value={uFormfieldObj.tempat_lahir || ""}
					onChange={(e)=>setFormfieldObj({...uFormfieldObj,tempat_lahir: (e.target.value)})}
					autoComplete="off"
					id="inptempatlahir"/>
				<div className="mx-1">,</div>
				</CInputGroup>

				<CInputGroup size="sm" className="">
				<CFormSelect size="sm"
					className="mb-2"
					style={{maxWidth:80,width:"auto"}}
					value={uFormfieldObj.tgl}
					onChange={(e)=>setFormfieldObj({...uFormfieldObj,tgl: (e.target.value)})}
					id="inplahirtgl">
					<option>-TGL-</option>
					{(cAngkaTgl||[]).map((vItems,vKeys)=>{
						return (<option key={vKeys} value={UFunc.leadZero(vItems)}>{UFunc.leadZero(vItems)}</option>)
					})}
				</CFormSelect>
				<span className="mx-1">/</span>
				<CFormSelect size="sm"
					className="mb-2 text-uppercase"
					style={{maxWidth:80,width:"auto"}}
					value={uFormfieldObj.bln}
					onChange={(e)=>setFormfieldObj({...uFormfieldObj,bln: (e.target.value)})}
					id="inplahirbln">
					<option>-BLN-</option>
					{(cBulanPendek||[]).map((vItems,vKeys)=>{
						return (<option className="text-uppercase" key={vKeys} value={UFunc.leadZero(vKeys+1)}>{vItems}</option>)
					})}
				</CFormSelect>
				<span className="mx-1">/</span>
				<CFormSelect size="sm"
					className="mb-2"
					style={{maxWidth:95,width:"auto"}}
					value={uFormfieldObj.thn}
					onChange={(e)=>setFormfieldObj({...uFormfieldObj,thn: (e.target.value)})}
					id="inplahirthn">
					<option>-THN-</option>
					{(uThnlahirArr||[]).map((vItems,vKeys)=>{
						return (<option key={vKeys} value={vItems}>{vItems}</option>)
					})}
				</CFormSelect>
				</CInputGroup>
			</CCol>
			</CRow>

			<CRow className="my-2">
			<CCol md="5" lg="4" className="fw-bolder">Jenis Kelamin</CCol>
			<CCol md="7" lg="5">
				<CFormSelect size="sm"
					value={uFormfieldObj.sex_pasien}
					onChange={(e)=>setFormfieldObj({...uFormfieldObj,sex_pasien: (e.target.value)})}
					className=""
					id="inpsex">
				<option value="L">Laki-laki [L]</option>
				<option value="P">Perempuan [P]</option>
				</CFormSelect>
			</CCol>
			</CRow>

			<CRow className="my-2">
			<CCol md="5" lg="4" className="">Agama</CCol>
			<CCol md="7" lg="5">
				<CInputGroup size="sm">
				<CFormInput size="sm" readOnly={true}
					className="text-capitalize"
					placeholder="--Klik Untuk Pilih.."
					maxLength={100}
					value={uFormfieldObj.agama_caption||""}
					onClick={()=>hdlKlikagamalookup()}
					autoComplete="off"
					id="inpagama"/>
				<CButton size="sm" color="dark"
					onClick={()=>hdlKlikagamalookup()}
					id="btnAgamalookup">
					<CIcon icon="cilSearch"/>
				</CButton>
				</CInputGroup>
			</CCol>
			</CRow>

			<div className="my-3 classborderbottom"/>

			<CRow className="my-2">
			<CCol md="5" lg="4" className="fw-bolder">Telp/HP</CCol>
			<CCol md="7" lg="5">
				<CFormInput size="sm"
					className="text-uppercase"
					maxLength={35}
					value={uFormfieldObj.telpon_pasien||""}
					onChange={(e)=>setFormfieldObj({...uFormfieldObj,telpon_pasien: (e.target.value)})}
					autoComplete="off"
					id="inptelphp"/>
			</CCol>
			</CRow>

			<CRow className="my-2">
			<CCol md="5" lg="4" className="fw-bolder">Alamat</CCol>
			<CCol md="7" lg="8">
				<CFormTextarea size="sm"
					rows={3}
					maxLength={255}
					value={UFunc.br2nl(uFormfieldObj.alamat_pasien)}
					onChange={(e)=>setFormfieldObj({...uFormfieldObj,alamat_pasien: UFunc.nl2br(e.target.value)})}
					autoComplete="off"
					id="inpalamat"/>
				<div className="classpetunjuk">&#8627; {uBahasaObj.petunjuk_textarea||"Ganti Baris Tekan [SHIFT]+[ENTER]"}</div>
			</CCol>
			</CRow>

			<CRow className="my-2 d-">
			<CCol md="5" lg="4" className="d-none d-md-block">Wilayah Administrasi</CCol>
			<CCol md="7" lg="8" className="">
				<div className="d-grid gap-2 gap-md-1 d-md-block d-lg-inline-block me-lg-1">
				
				<CTooltip className="d-none d-lg-block" content="--Reset Kewilayahan Alamat..">
				<CLink onClick={()=>hdlKlikResetwilayah()} className="classcursorpointer d-none d-md-inline">
					<CIcon icon="cilSync" className="classikonbox align-middle mx-0 me-1" height={23}/>
				</CLink>
				</CTooltip>

				<CButton size="sm" color="dark" variant="outline" className="px-2" 
					onClick={()=>hdlKlikWilayah("PROPINSI")}
					id="btnpropinsi">
				{uFormfieldObj.propinsi===undefined ? (
					<small>Pilih Propinsi</small>
				) : (
					<small className="fw-bolder">{(uFormfieldObj.propinsi.name||"").toUpperCase()}</small>
				)}
				<CIcon icon="cilSearch" className="ms-1"/>
				</CButton>

				<span className="ms-1 d-none d-md-inline"/>

				<CButton size="sm" color="primary" variant="outline" className="px-2" 
					onClick={()=>hdlKlikWilayah("KOTA")}
					id="btnkota">
				{uFormfieldObj.kota===undefined ? (
					<small>Pilih Kota</small>
				) : (
					<small className="fw-bolder">{(uFormfieldObj.kota.name||"").toUpperCase()}</small>
				)}
				<CIcon icon="cilSearch" className="ms-1"/>
				</CButton>

				</div>
				<div className="d-grid gap-2 gap-md-1 d-md-block d-lg-inline-block mt-2">

				<CButton size="sm" color="warning" variant="outline" className="px-2" 
					onClick={()=>hdlKlikWilayah("DISTRIK")}
					id="btndistrik">
				{uFormfieldObj.distrik===undefined ? (
					<small>Pilih Kecamatan</small>
				) : (
					<small className="fw-bolder">{(uFormfieldObj.distrik.name||"").toUpperCase()}</small>
				)}
				<CIcon icon="cilSearch" className="ms-1"/>
				</CButton>

				<span className="ms-1 d-none d-md-inline"/>

				<CButton size="sm" color="success" variant="outline" className="px-2" 
					onClick={()=>hdlKlikWilayah("VILLAGE")}
					id="btnvillage">
				{uFormfieldObj.village===undefined ? (
					<small>Pilih Desa/Kelurahan</small>
				) : (
					<small className="fw-bolder">{(uFormfieldObj.village.name||"").toUpperCase()}</small>
				)}
				<CIcon icon="cilSearch" className="ms-1"/>
				</CButton>
				</div>
			</CCol>
			</CRow>

			<div className="my-3 classborderbottom"/>

			<CRow className="my-2">
			<CCol md="5" lg="4">Asuransi</CCol>
			<CCol md="7" lg="5">
				<CInputGroup size="sm">
				<CFormInput size="sm"
					className="text-capitalize"
					placeholder="--Masukkan Keyword Untuk Memilih.."
					maxLength={100}
					value={uFormfieldObj.asuransi_caption||""}
					onChange={(e)=>setFormfieldObj({...uFormfieldObj,asuransi_caption: UFunc.nl2br(e.target.value)})}
					onKeyDown={(e)=>hdlKDownasuransi(e)}
					autoComplete="off"
					id="inpasuransi"/>
				<CButton size="sm" color="dark"
					onClick={()=>hdlKlikasuransilookup()}
					id="btnAsuransilookup">
					<CIcon icon="cilSearch"/>
				</CButton>
				</CInputGroup>
			</CCol>
			<CCol md="5" lg="4" className="d-none d-md-block"/>
			<CCol md="7" lg="8">
				<div className="classpetunjuk">
				&#8627; Kosongi Jika Asuransi UMUM (TIDAK ADA Asuransi)
				</div>
			</CCol>
			</CRow>

			<CRow className="my-2">
			<CCol md="5" lg="4">Pekerjaan</CCol>
			<CCol md="7" lg="5">
				<CInputGroup size="sm">
				<CFormInput size="sm"
					className="text-capitalize"
					placeholder="--Masukkan Keyword Untuk Memilih.."
					maxLength={100}
					value={uFormfieldObj.pekerjaan_caption||""}
					onChange={(e)=>setFormfieldObj({...uFormfieldObj,pekerjaan_caption: UFunc.nl2br(e.target.value)})}
					onKeyDown={(e)=>hdlKDownpekerjaan(e)}
					autoComplete="off"
					id="inppekerjaan"/>
				{((uFormfieldObj.pekerjaan_caption||"").trim()!=="" && parseInt(uFormfieldObj.pekerjaan_id) <= 0 ) && (
					<CInputGroupText className="py-0 px-1 border bg-transparent">
					<CImage src={pjson.homepage+"api/images/icon_new.png"} height={30} className="ms-1 classblinking"/>
					</CInputGroupText>
				)}
				{(isMobile) && (
				<CButton size="sm" color="dark"
					onClick={()=>hdlKlikpekerjaanlookup()}
					id="btnPekerjaanlookup">
					<CIcon icon="cilSearch"/>
				</CButton>
				)}
				</CInputGroup>
			</CCol>
			</CRow>

			<div className="my-3 classborderbottom"/>

			<CRow className="my-2">
			<CCol md="5" lg="4">Alergi</CCol>
			<CCol md="7" lg="8">
				<CFormInput size="sm"
					className="text-capitalize"
					maxLength={100}
					value={uFormfieldObj.alergi||""}
					onChange={(e)=>setFormfieldObj({...uFormfieldObj,alergi: UFunc.nl2br(e.target.value)})}
					autoComplete="off"
					id="inpalergi"/>
			</CCol>
			</CRow>

			<CRow className="my-2">
			<CCol md="5" lg="4">
				Kondisi Khusus
				<span className="d-lg-block ms-1 ms-lg-0 px-0 classpetunjuk">
				<small>(Yang Perlu Diperhatikan)</small>
				</span>
			</CCol>
			<CCol md="7" lg="8">
				<CFormInput size="sm"
					className="text-capitalize"
					maxLength={60}
					value={uFormfieldObj.keterangan||""}
					onChange={(e)=>setFormfieldObj({...uFormfieldObj,keterangan: UFunc.nl2br(e.target.value)})}
					onKeyDown={(e)=>{
						if(!uShowbutton)
							UFunc.hdlKeyDownInput(e,"btnDialogSimpan")
					}}
					autoComplete="off"
					id="inpketerangan"/>
			</CCol>
			</CRow>
		</>
		)//>
	}

	const apiLoadinit = () => {
		const vDATAS	= JSON.stringify({
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_pasien/ld_cardform";

		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false);return response.json(); }})
		.then((output_string) => {
			const vTimeEnd = new Date(); const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
			if(output_string.tampil) {
				//console.log("(MyCardformpasien - apiLoadinit) output_string.dataobject : "+output_string.dataobject);
				const vTmpArr = JSON.parse(output_string.dataobject || "[]");
				const vPekerjaanArr = vTmpArr.map(vItems => {
					return {id:vItems.id,caption:vItems.pekerjaan_caption}
				})	
				setPekerjaanArr(vPekerjaanArr);

				const vAsuransiArr = (JSON.parse(output_string.dataasuransi || "[]")).
					map(vItems => ({id:vItems.id,caption:vItems.asuransi_caption}));
				setAsuransiArr(vAsuransiArr);

				setAgamaArr(JSON.parse(output_string.dataagama || "[]"));
			} else if(output_string.info) {
				console.log("(MyCardformpasien - apiLoadinit) output_string.info : "+output_string.info);
			} else if(output_string.errors) {
				console.log("(MyCardformpasien - apiLoadinit) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
			} else if(output_string.expired) {
				setLoading(true); prosesExpired(); return;
			}

			if(vTimeDiff > 500) setSessionaktif(true);
			else {
				let vTimeout = setTimeout(()=>{ clearTimeout(vTimeout); setSessionaktif(true);},500)
			}
		})
		.catch((error) =>{
			console.log("(MyCardformpasien - apiLoadinit) catch-error : "+error);
		});
	}
	const apiLoadpasien = (_IDPASIEN) => {
		setApimsg();
		setPasienloadObj({});
		setDlgloading(true);

		const vDATAS	= JSON.stringify({
			send_pasienid : _IDPASIEN,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_pasien/ld_detil";

		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false);return response.json(); }})
		.then((output_string) => {
			const vTimeEnd = new Date(); const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
			setDlgloading(false);
			if(output_string.tampil) {
				const vTmpObj	= JSON.parse(output_string.datapasien||"{}");
				if(JSON.stringify(vTmpObj||"{}")==="{}") {
					setApimsg(uBahasaObj.caption_dataempty||"Maaf, Data Tidak Ditemukan !");
					return;
				}
				setPasienloadObj(vTmpObj);
			} else if(output_string.info) {
				setApimsg(output_string.info);
			} else if(output_string.errors) {
				console.log("(MyCardformpasien - apiLoadpasien) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				setApimsg("<div class='text-danger'>"+vMsg+"</div>");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired(); return
			}

			if(vTimeDiff > 500) setSessionaktif(true);
			else {
				let vTimeout = setTimeout(()=>{ clearTimeout(vTimeout); setSessionaktif(true);},500)
			}
		})
		.catch((error) =>{
			setDlgloading(false);
			console.log("(MyCardformpasien - apiLoadpasien) catch-error : "+error);
			setApimsg(pjson.mydefault.msg500str.join(" "));
		});
	}
	const apiLoadwilayah = (_JENIS) => {
		_JENIS = (_JENIS||"").toUpperCase();
		//const vTokensatusehatObj= JSON.parse(localStorage.getItem("tokensatusehat")||"{}");
		const vAccesstoken 		= uTokensatusehatObj.access_token;
		const vNextfunction 	= () => apiLoadwilayah(_JENIS);
		
 		if(!vAccesstoken) {
 			loadToken(vNextfunction); return;
 		}
		const vLimitedsec		= parseInt(uTokensatusehatObj.expires_in || "0");
		const vTimestampnow 	= new Date();
		const vTimetoken		= new Date(parseInt(uTokensatusehatObj.issued_at || "0"));
		const vSelisih			= UFunc.Datetimeselisih(vTimetoken,vTimestampnow).dtk;

		if(vSelisih > vLimitedsec) {
 			loadToken(vNextfunction); return;
		}

		let vElbutton;
		let vURLwilayah;
		let vDataObj	 = {
			send_accesstoken : vAccesstoken,
			send_tokenauth : uTokenObj.userinit
		}
		if(_JENIS === "PROPINSI") {
			vElbutton 	= document.getElementById("btnpropinsi");
			vURLwilayah	= pjson.homepage+"api2/api_init/ld_propinsi";
		} else if(_JENIS === "KOTA") {
			vElbutton 	= document.getElementById("btnkota");
			vDataObj	= {...vDataObj,
				send_kodepropinsi : (uFormfieldObj.propinsi||{}).code || "0"
			}
			vURLwilayah	= pjson.homepage+"api2/api_init/ld_kota";
		} else if(_JENIS === "DISTRIK") {
			vElbutton 	= document.getElementById("btndistrik");
			vDataObj	= {...vDataObj,
				send_kodekota : uFormfieldObj.kota.code || "0",
			}
			vURLwilayah	= pjson.homepage+"api2/api_init/ld_distrik";
		} else if(_JENIS === "VILLAGE") {
			vElbutton 	= document.getElementById("btnvillage");
			vDataObj	= {...vDataObj,
				send_kodedistrik : uFormfieldObj.distrik.code || "0",
			}
			vURLwilayah	= pjson.homepage+"api2/api_init/ld_village";
		}
		vElbutton && (vElbutton.disabled = true);
		setLoading(true);

		/*let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
		},2000); return;//--*/

		const vDATAS	= JSON.stringify(vDataObj);
		const vURLs	= vURLwilayah;

		const vTimeBegin = new Date();
		fetch(vURLs,{
			method: "POST",
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			const vTimeEnd = new Date(); const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
			vElbutton && (vElbutton.disabled = false);
			setLoading(false);
			if(output_string.tampil) {
				//console.log("(MyCardformpasien - apiLoadwilayah) output_string.datakota => "+output_string.datakota)
				let vTmpArr;
				if(_JENIS === "PROPINSI") {
				 	vTmpArr	= JSON.parse(output_string.datapropinsi || "[]");
					uWilayahObj.propinsi_arr = vTmpArr;
					uDlglookupObj.headers	= (uBahasaObj.word_lookup||"Lookup")+": "+
						(uBahasaObj.word_propinsi||"Provinsi").toUpperCase();
				} else if(_JENIS === "KOTA") {
				 	vTmpArr	= JSON.parse(output_string.datakota || "[]");
					uWilayahObj.kota_arr 	= vTmpArr;
					uDlglookupObj.headers	= (uBahasaObj.word_lookup||"Lookup")+": "+
						(uBahasaObj.word_kota||"Kota").toUpperCase();
				} else if(_JENIS === "DISTRIK") {
				 	vTmpArr	= JSON.parse(output_string.datadistrik || "[]");
					uWilayahObj.distrik_arr	= vTmpArr;
					uDlglookupObj.headers	= (uBahasaObj.word_lookup||"Lookup")+": "+
						(uBahasaObj.word_distrik||"Distrik").toUpperCase();
				} else if(_JENIS === "VILLAGE") {
				 	vTmpArr	= JSON.parse(output_string.datavillage || "[]");
					uWilayahObj.village_arr	= vTmpArr;
					uDlglookupObj.headers	= (uBahasaObj.word_lookup||"Lookup")+": "+
						(uBahasaObj.word_village||"Village").toUpperCase();
				}

				const vDatalookupArr = (vTmpArr||[]).map(vItems=>{
					return {id:vItems.code,caption:(vItems.name||"").toUpperCase()}
				})
				uDlglookupObj.jenis			= _JENIS;
				uDlglookupObj.data_arr		= vDatalookupArr;
				
				setDlglookupshow(true)
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(MyCardformpasien - apiLoadwilayah) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired(); return
			}

			if(vTimeDiff > 500) setSessionaktif(true);
			else {
				let vTimeout = setTimeout(()=>{ clearTimeout(vTimeout); setSessionaktif(true);},500)
			}
		})
		.catch((error) =>{
			vElbutton && (vElbutton.disabled = false);
			setLoading(false);
			console.log("(MyCardformpasien - apiLoadwilayah) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	const apiProsessimpan = () => {
		const vPasienID = parseInt(pasienID)||0;
		uDispatch({type: "set", gInitprosespasien: false});

		let vTanggallahir 	= uFormfieldObj.thn+"-"+uFormfieldObj.bln+"-"+uFormfieldObj.tgl;
		const visValiddate = parseInt(uFormfieldObj.thn) > 0 
			&& (parseInt(uFormfieldObj.bln) > 0 && parseInt(uFormfieldObj.bln) <= 12)
			&& (parseInt(uFormfieldObj.tgl) > 0 && parseInt(uFormfieldObj.tgl) <= 31);
		if(!visValiddate) vTanggallahir = "";

		//const vTanggallahirDT 	= new Date(vTanggallahir)
		if(!UFunc.isDateValid(vTanggallahir)) {
			vTanggallahir = "";
		}
		uFormfieldObj.tgl_lahir = vTanggallahir;

		const vRegisterihsBl = 
			((uPasienloadObj.nik||"").trim() !== (uFormfieldObj.nik||"").trim() &&
				(uFormfieldObj.nik||"").trim() !== "" )
			|| ((uFormfieldObj.nik||"").trim() !== "" && (uFormfieldObj.ihs_number||"")==="" )

		const vElbutton = document.getElementById("btnSimpan");
		const vElDlgbutton = document.getElementById("btnDialogSimpan");
		vElDlgbutton && (vElDlgbutton.disabled = true);
		vElbutton && (vElbutton.disabled = true);
		setLoading(true);

		/*let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			vElbutton && (vElbutton.disabled = false);
			setLoading(false);
		},2000); return;//--*/

		const vDATAS	= JSON.stringify({
			send_tabelid : vPasienID,
			send_datajson: JSON.stringify(uFormfieldObj),
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_pasien/pr_simpan";

		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false);return response.json(); }})
		.then((output_string) => {
			const vTimeEnd = new Date(); const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
			vElDlgbutton && (vElDlgbutton.disabled = false);
			vElbutton && (vElbutton.disabled = false);
			setLoading(false);
			if(output_string.sukses) {
				if(vPasienID <= 0) {
					const vPasienIDresponse = output_string.tabelid || "0";
					if(vRegisterihsBl) {
						apiRegisterihs(vPasienIDresponse);
						return;
					}

					initFormawal();
					if(!isMobile) {
						const vElfocus = document.getElementById("inpnamalengkap");
						vElfocus && vElfocus.focus();
					}

					showToast(uBahasaObj.pesan_sukses,"SUKSES");
				} else {
					if(vRegisterihsBl) {
						apiRegisterihs(vPasienID);
						return;
					}

					const vWilayahObj 	= uFormfieldObj.propinsi && ({
						propinsi: uFormfieldObj.propinsi,
						kota: uFormfieldObj.kota,
						distrik: uFormfieldObj.distrik,
						village: uFormfieldObj.village,
					});

					const vTmpObj = {
						pasien_caption : uFormfieldObj.nama_lengkap_pasien,
						panggilan : uFormfieldObj.nama_panggilan_pasien,
						sex : uFormfieldObj.sex_pasien,
						tgl_lahir : vTanggallahir,
						umur : output_string.umur || "",
						telp_hp : uFormfieldObj.telpon_pasien,
						alamat : (uFormfieldObj.alamat_pasien),
						pekerjaan : uFormfieldObj.pekerjaan_caption,
						asuransi : uFormfieldObj.asuransi_caption,
						alergi : uFormfieldObj.alergi,
						keterangan : uFormfieldObj.keterangan,
						nik : uFormfieldObj.nik,
						ihs_number : uFormfieldObj.ihs_number,
						wilayah_obj: vWilayahObj,
					}
					uDispatch({type: "set", gInitprosespasien: true});
					uDispatch({type: "set", gPasiendetilObj: vTmpObj});
				}
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(MyCardformpasien - apiProsessimpan) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired(); return
			}

			if(vTimeDiff > 500) setSessionaktif(true);
			else {
				let vTimeout = setTimeout(()=>{ clearTimeout(vTimeout); setSessionaktif(true);},500)
			}
		})
		.catch((error) =>{
			vElDlgbutton && (vElDlgbutton.disabled = false);
			vElbutton && (vElbutton.disabled = false);
			setLoading(false);
			console.log("(MyCardformpasien - apiProsessimpan) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	const apiRegisterihs = (_IDTABEL) => {
		const vAccesstoken 		= uTokensatusehatObj.access_token;
		
 		if(!vAccesstoken) {
 			loadToken(apiRegisterihs); return;
 		}
		const vLimitedsec		= parseInt(uTokensatusehatObj.expires_in || "0");
		const vTimestampnow 	= new Date();
		const vTimetoken		= new Date(parseInt(uTokensatusehatObj.issued_at || "0"));
		const vSelisih			= UFunc.Datetimeselisih(vTimetoken,vTimestampnow).dtk;

		if(vSelisih > vLimitedsec) {
 			loadToken(apiRegisterihs); return;
		}

		_IDTABEL 		= parseInt(_IDTABEL)||0;
		const vPasienID = parseInt(pasienID)||0;
		uDispatch({type: "set", gInitprosespasien: false});

		let vTanggallahir 	= uFormfieldObj.thn+"-"+uFormfieldObj.bln+"-"+uFormfieldObj.tgl;
		const visValiddate = parseInt(uFormfieldObj.thn) > 0 
			&& (parseInt(uFormfieldObj.bln) > 0 && parseInt(uFormfieldObj.bln) <= 12)
			&& (parseInt(uFormfieldObj.tgl) > 0 && parseInt(uFormfieldObj.tgl) <= 31);
		if(!visValiddate) vTanggallahir = "";

		//const vTanggallahirDT 	= new Date(vTanggallahir)
		if(!UFunc.isDateValid(vTanggallahir)) {
			vTanggallahir = "";
		}

		const vElbutton = document.getElementById("btnSimpan");
		const vElDlgbutton = document.getElementById("btnDialogSimpan");
		vElDlgbutton && (vElDlgbutton.disabled = true);
		vElbutton && (vElbutton.disabled = true);
		setLoading(true);

		/*let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			vElbutton && (vElbutton.disabled = false);
			setLoading(false);
		},2000); return;//--*/

		const vDATAS	= JSON.stringify({
			send_tabelid : _IDTABEL,
			send_accesstoken : vAccesstoken,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_pasien/pr_registerihs";

		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false);return response.json(); }})
		.then((output_string) => {
			const vTimeEnd = new Date(); const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
			vElDlgbutton && (vElDlgbutton.disabled = false);
			vElbutton && (vElbutton.disabled = false);
			setLoading(false);

			const vIHSnumber	= output_string.ihs_number || "";
			const vIHSmessage 	= output_string.ihs_message || "";
			if(vPasienID > 0) {
				const vWilayahObj 	= uFormfieldObj.propinsi && ({
					propinsi: uFormfieldObj.propinsi,
					kota: uFormfieldObj.kota,
					distrik: uFormfieldObj.distrik,
					village: uFormfieldObj.village,
				});

				const vTmpObj = {
					pasien_caption : uFormfieldObj.nama_lengkap_pasien,
					panggilan : uFormfieldObj.nama_panggilan_pasien,
					sex : uFormfieldObj.sex_pasien,
					tgl_lahir : vTanggallahir,
					umur : output_string.umur || "",
					telp_hp : uFormfieldObj.telpon_pasien,
					alamat : UFunc.nl2br(uFormfieldObj.alamat_pasien),
					pekerjaan : uFormfieldObj.pekerjaan_caption,
					asuransi : uFormfieldObj.asuransi_caption,
					alergi : uFormfieldObj.alergi,
					keterangan : uFormfieldObj.keterangan,
					nik : uFormfieldObj.nik,
					ihs_number : vIHSnumber,
					wilayah_obj: vWilayahObj,
				}

				uDispatch({type: "set", gInitprosespasien: true});
				uDispatch({type: "set", gPasiendetilObj: vTmpObj});
			} else {
				initFormawal();
				if(!isMobile) {
					const vElfocus = document.getElementById("inpnamalengkap");
					vElfocus && vElfocus.focus();
				}
			}

			if(output_string.sukses) {
				if(vPasienID <= 0) {
					let vOutputmsg = uBahasaObj.pesan_sukses || "SUKSES";
					if(vIHSmessage !== "")
						vOutputmsg	+= "<br/><br/>SATUSEHAT: <b>"+vIHSmessage+"</b>";

					showToast(vOutputmsg,"SUKSES");
				} else {
					if(vIHSmessage !== "")
						showToast("SATUSEHAT: <b>"+vIHSmessage+"</b>","SUKSES");
				}
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(MyCardformpasien - apiRegisterihs) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}

			if(vTimeDiff > 500) setSessionaktif(true);
			else {
				let vTimeout = setTimeout(()=>{ clearTimeout(vTimeout); setSessionaktif(true);},500)
			}
		})
		.catch((error) =>{
			vElDlgbutton && (vElDlgbutton.disabled = false);
			vElbutton && (vElbutton.disabled = false);
			setLoading(false);
			console.log("(MyCardformpasien - apiRegisterihs) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}

	React.useEffect(()=>{
		apiLoadinit()
		
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);

			if(!isMobile) {
				const vElfocus = document.getElementById("inpnamalengkap");
				vElfocus && vElfocus.focus();
			}
		},350);

		return () => {
			setPasienloadObj({});
			setPekerjaanArr([]);
			setAsuransiArr([]);
			setAgamaArr([]);
			initFormawal();
			setWilayahObj({})
			setDlglookupshow(false);
		}
	},[])
	React.useEffect(()=>{
		const vBatasyear= parseInt(uSystemsetting.start_tahunlahir || "1950");
		const vYearnow	= (new Date).getFullYear();
		const vTmptahun	= [];
		for(var vIdx=vYearnow;vIdx >= vBatasyear; vIdx--)
			vTmptahun.push(vIdx);
		setThnlahirArr(vTmptahun);
	},[uSystemsetting])
	React.useEffect(()=>{
		//console.log("(MyCardformpasien [pasienID]) pasienID 1 = "+pasienID)
		if((parseInt(pasienID)||0) <= 0) { initFormawal(); return}

		//console.log("(MyCardformpasien [pasienID]) pasienID 2 = "+pasienID)
		apiLoadpasien(pasienID);
	},[pasienID])
	React.useEffect(()=>{
		if(uFormfieldObj.sex_pasien===undefined)
			uFormfieldObj.sex_pasien = "L";
		if(uFormfieldObj.tgl===undefined)
			uFormfieldObj.tgl = "0";
		if(uFormfieldObj.bln===undefined)
			uFormfieldObj.bln = "0";
		if(uFormfieldObj.thn===undefined)
			uFormfieldObj.thn = "0";
	},[uFormfieldObj,
	uFormfieldObj.tgl,
	uFormfieldObj.bln,
	uFormfieldObj.thn,
	uFormfieldObj.sex_pasien
	])
	React.useEffect(()=>{
		if((uFormfieldObj.nik||"").trim() !== (uFormfieldObj.nik_before||"").trim())
			uFormfieldObj.ihs_number = "";
		else
			uFormfieldObj.ihs_number = uPasienloadObj.ihs_number||"";
	},[uFormfieldObj,
	uFormfieldObj.nik
	])
	React.useEffect(()=>{
		if(JSON.stringify(uPasienloadObj)==="{}") return;
		//console.log("(MyCardformpasien [uPasienloadObj]) uPasienloadObj => "+JSON.stringify(uPasienloadObj))

		const vTanggallahir = uPasienloadObj.tgl_lahir||"";
		let vTgl = "0";
		let vBln = "0";
		let vThn = "0";
		if(vTanggallahir !== "") {
			const vTanggallahirDT = UFunc.toDate(vTanggallahir);

			vTgl = UFunc.leadZero(vTanggallahirDT.getDate());
			vBln = UFunc.leadZero(vTanggallahirDT.getMonth()+1);
			vThn = UFunc.leadZero(vTanggallahirDT.getFullYear());
		}

		uFormfieldObj.nama_lengkap_pasien = (uPasienloadObj.pasien_caption || "");
		uFormfieldObj.no_rm 	= (uPasienloadObj.no_rm || "1");
		uFormfieldObj.nama_panggilan_pasien = (uPasienloadObj.panggilan || "");
		uFormfieldObj.sex_pasien = (uPasienloadObj.sex || "L");
		uFormfieldObj.tgl 		= (vTgl); uFormfieldObj.bln = (vBln); uFormfieldObj.thn = (vThn);

		uFormfieldObj.tempat_lahir 	= (uPasienloadObj.tempat_lahir || "");
		uFormfieldObj.telpon_pasien = (uPasienloadObj.telp_hp || "");
		uFormfieldObj.alamat_pasien = (UFunc.br2nl(uPasienloadObj.alamat || ""));
		uFormfieldObj.alergi 		= (uPasienloadObj.alergi || "");
		uFormfieldObj.keterangan 	= (uPasienloadObj.keterangan || "");
		uFormfieldObj.nik 			= (uPasienloadObj.nik || "");
		uFormfieldObj.nik_before 	= (uPasienloadObj.nik || "");
		uFormfieldObj.ihs_number 	= (uPasienloadObj.ihs_number || "");
		uFormfieldObj.agama_id 		= (uPasienloadObj.agama_id);
		uFormfieldObj.agama_caption	= (uPasienloadObj.agama_caption || "");

		const vPekerjaancaption 	= uPasienloadObj.pekerjaan_caption || "";
		uFormfieldObj.pekerjaan_caption = (vPekerjaancaption);
		const vPekerjaanidx 		= UFunc.getObjectIndeks(uPekerjaanArr,vPekerjaancaption,"caption");
		uFormfieldObj.pekerjaan_id 	= ((uPekerjaanArr[vPekerjaanidx]||{}).id);

		const vAsuransicaption 		= uPasienloadObj.asuransi_caption || "";
		uFormfieldObj.asuransi_caption = (vAsuransicaption);
		const vAsuransiidx 			= UFunc.getObjectIndeks(uAsuransiArr,vAsuransicaption,"caption");
		uFormfieldObj.asuransi_id 	= ((uAsuransiArr[vAsuransiidx]||{}).id);

		const vWilayahObj 			= uPasienloadObj.wilayah_obj || {};
		vWilayahObj.propinsi && (uFormfieldObj.propinsi = vWilayahObj.propinsi);
		vWilayahObj.kota && (uFormfieldObj.kota = vWilayahObj.kota);
		vWilayahObj.distrik && (uFormfieldObj.distrik = vWilayahObj.distrik);
		vWilayahObj.village && (uFormfieldObj.village = vWilayahObj.village);
		//console.log("(MyCardformpasien [uPasienloadObj]) vWilayahObj => "+JSON.stringify(vWilayahObj.kota));

		if(!isMobile) {
			const vElfocus = document.getElementById("inpnamalengkap");
			vElfocus && vElfocus.focus();
		}
	},[uPasienloadObj])
	React.useEffect(()=>{
		if((simpanKlik||false)===false) return;
		hdlKlikSimpan()
	},[simpanKlik])
	React.useEffect(()=>{ setShowbutton(showButton); },[showButton])
	React.useEffect(()=>{
		if(!uISDlglookupshow)
			{ setDlglookupObj({}); return }
	},[uISDlglookupshow])
	React.useEffect(()=>{
		if(uFormfieldObj === undefined) return;
		//if(uFormfieldObj.propinsi.code === undefined) return;

		uWilayahObj.kota_arr	= undefined;
		uWilayahObj.distrik_arr	= undefined;
		uWilayahObj.village_arr	= undefined;
	},[uFormfieldObj,
	(uFormfieldObj.propinsi||{}).code
	]);
	React.useEffect(()=>{
		if(uFormfieldObj === undefined) return;
		//if(uFormfieldObj.kota.code === undefined) return;

		uWilayahObj.distrik_arr	= undefined;
		uWilayahObj.village_arr	= undefined;
	},[uFormfieldObj,
	(uFormfieldObj.kota||{}).code
	]);
	React.useEffect(()=>{
		if(uFormfieldObj === undefined) return;
		//if(uFormfieldObj.distrik.code === undefined) return;

		uWilayahObj.village_arr	= undefined;
	},[uFormfieldObj,
	(uFormfieldObj.distrik||{}).code
	]);

	//console.log("(MyCardformpasien) pasienID = "+pasienID)
	return (
		<>
		<CForm>
		<CCard className="classbgcard">
		<CCardHeader className="d-flex justify-content-between align-items-center">
		<strong>{parseInt(pasienID||0)<=0
			?(uBahasaObj.caption_inputpasienbaru||"Input Pasien Baru")
			:"Edit Data Pasien"}</strong>
		<CLink onClick={()=>hdlKlikReset()}
			className="classikon classikonreset classcursorpointer"/>
		</CCardHeader>

		<CCardBody className={(uShowbutton)?"px-lg-5":""}>{contentMain()}</CCardBody>

		{(uShowbutton===true) && (
		<CCardFooter className={"text-center"}>
			<MyButton
				onClick={()=>hdlKlikSimpan()}
				iconname="cilCheckAlt"
				id="btnSimpan">S I M P A N</MyButton>
		</CCardFooter>
		)}
		</CCard>
		</CForm>

		<MyDialoglookup
			show={uISDlglookupshow}
			toggle={()=>setDlglookupshow(false)}
			dialogHeader={uDlglookupObj.headers||"Lookup Data"}
			inputValue={uDlglookupObj.inputvalue||""}
			dataItemArr={uDlglookupObj.data_arr || []} 
			onKlikPilihItem={hdlKlikDlglookuppilih}
			id="iddialoglookup"
			{...props}/>
		</>
	)//>
}
MyCardformpasien.defaultProps = {
	pasienID: 0,            
	showButton: true,     
	simpanKlik: false,
};

MyCardformpasien.propTypes = {
	pasienID: PropTypes.number,            
	showButton: PropTypes.bool,     
	simpanKlik: PropTypes.bool,
}

export default MyCardformpasien;